import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Cookiespage } from 'src/app/models/cookiespage.model';
import { MediaService } from 'src/app/services/media.service';
import { PageService } from 'src/app/services/page.service';

@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.sass'],
  encapsulation: ViewEncapsulation.None
})
export class CookiesComponent implements OnInit {

  pagedata: Cookiespage = new Cookiespage;

  constructor(private pageService:PageService, private mediaService:MediaService) { }

  ngOnInit(): void {

    this.pageService.getPage("cookie").subscribe(data => {
      this.pagedata = data.data;

      this.pagedata.foto1 = this.mediaService.getMediaItemUrl(this.pagedata.foto1);
      this.pagedata.foto2 = this.mediaService.getMediaItemUrl(this.pagedata.foto2);
    });
  }

}
